import {
    ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_AFEGIR_OBSERVADOR,
    ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_ELIMINAR_OBSERVADOR,
    ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_MODIFICAR_OBSERVADOR
} from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = {
    originals: [],
    editades: []
};

/**
 * Busca l'element d'un array i modifica el seu contingut. 
 * La funció es pura i retorna un nou array.
 * @param {array} array 
 * @param {number} indexToFind 
 * @param {object} dades 
 */
const modificarElementDeUnaLlistaPerIndex = (array, indexABuscar, dades) => {
    return array.map((item, index) => {
        if (index !== indexABuscar) {
            return item;
        }

        return {
            ...item,
            ...dades
        };
    });
};

const historicObservadors = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return {
                originals: action.estructuraIDades.dades.historicObservadors,
                editades: action.estructuraIDades.dades.historicObservadors
            };

        case ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS:
            return {
                ...state,
                editades: state.originals
            };

        case ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_AFEGIR_OBSERVADOR:
            if(!action.observador) {
                return {...state};
            }

            return {
                ...state,
                editades: [action.observador, ...state.editades]
            };

        case ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_ELIMINAR_OBSERVADOR:
            return {
                ...state,
                editades: state.editades.filter((item, index) => index !== action.indexObservador)
            };

        case ESTACIO_INTRODUCCIO_HISTORIC_OBSERVADORS_MODIFICAR_OBSERVADOR:
            return {
                ...state,
                editades: modificarElementDeUnaLlistaPerIndex(state.editades, action.indexObservador, action.data)
            };

        default:
            return state;
    }
};

export default historicObservadors;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/historicObservadors.js